export const MAX_INT_VALUE = 2147483647;

export const MIN_INT_VALUE = -2147483648;
